import { createReducer, on } from '@ngrx/store';
import { initialState } from './admin-categories.state';
import * as AdminCategoriesActions from './admin-categories.actions';

export const adminCategoriesReducer = createReducer(
  initialState,
  on(AdminCategoriesActions.loadAdminCategories, (state, { page }) => ({
    ...state,
    currentPage: page,
    isLoading: true,
    error: null
  })),
  on(AdminCategoriesActions.loadAdminCategoriesSuccess, (state, { response }) => ({
    ...state,
    categories: response.content,
    totalElements: response.totalElements,
    totalPages: response.totalPages,
    isLoading: false
  })),
  on(AdminCategoriesActions.loadAdminCategoriesFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false
  }))
);
